/* ═══════════════════════════════════════════════════════════
   ZAGARA WISHLIST — lux-wishlist.js
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var I18N = (window.ZAGARA && window.ZAGARA.i18n) || {};

  var STORAGE_KEY  = 'zagara_wishlist';
  var CHANGE_EVENT = 'zagara:wishlist:change';

  // La testata del telefono (giro finale, tappa 2, voce t2-soglia): UNA media query per tutto il JS,
  // window.ZAGARA.testataTelefono (luxury.js, primo blocco; 1151.98 px, come il CSS della testata e il foglio dal
  // basso di lux-wishlist.css). Sotto la soglia il foglio col velo, sopra il pannello ancorato all'icona (e il
  // passaggio del mouse). Prima qui c'era innerWidth <= 767. Senza luxury.js decide il CSS: si vede la testata del
  // telefono.
  function testataTelefono() {
    var mq = window.ZAGARA && window.ZAGARA.testataTelefono;
    if (mq) return mq.matches;
    var m = document.querySelector('.header-inner--m');
    return !!(m && getComputedStyle(m).display !== 'none');
  }

  // The header renders its controls once per breakpoint branch (desktop and
  // mobile markup): writes go to every instance, reads use the visible one.
  function wlToggles() { return document.querySelectorAll('[data-role="wishlist-toggle"]'); }
  function visibleWlToggle() {
    var list = wlToggles();
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) return list[i]; }
    return list[0] || null;
  }

  // ── State ────────────────────────────────────────────────────
  var wishlist = [];

  function load() {
    try { wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { wishlist = []; }
  }

  function save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: wishlist }));
  }

  function has(id) {
    id = String(id);
    return wishlist.some(function (p) { return String(p.id) === id; });
  }

  function add(product) {
    if (has(product.id)) return;
    product.id = String(product.id);
    product.addedAt = Date.now();
    wishlist.unshift(product);
    save();
  }

  function remove(id) {
    id = String(id);
    wishlist = wishlist.filter(function (p) { return String(p.id) !== id; });
    save();
  }

  function clear() { wishlist = []; save(); }

  // ── Cross-tab sync ───────────────────────────────────────────
  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    load();
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: wishlist }));
  });

  // ── Product data from button ─────────────────────────────────
  // Giro finale, voce 1 (07/10/2026): con il prodotto si salvano anche la
  // variante che la scheda aggiungerebbe, «prezzi diversi» e la disponibilita'
  // (data-product-variant / -price-varies / -available sui cuori di
  // zg-product-card e main-product; nella scheda prodotto la variante segue
  // la scelta). I preferiti salvati prima non hanno questi campi: non si
  // perdono. Quello che si salva e' una fotografia: la tengono aggiornata i
  // cuori della pagina (fillSaved) e, nella pagina dei preferiti, lo stato
  // vivo del prodotto (chiediVivo), da cui solo si decide il gesto.
  function variantFromBtn(btn) { return String(btn.dataset.productVariant || '').replace(/\D/g, ''); }
  function productFromBtn(btn) {
    var p = {
      id:       btn.dataset.productId  || btn.dataset.wishlist || '',
      name:     btn.dataset.productName  || '',
      price:    btn.dataset.productPrice || '',
      priceRaw: parseInt(btn.dataset.productPriceRaw || '0', 10),
      image:    btn.dataset.productImage || '',
      url:      btn.dataset.productUrl   || '',
      producer: btn.dataset.productVendor || ''
    };
    var v = variantFromBtn(btn);
    if (v) {
      p.variantId   = v;
      p.priceVaries = btn.dataset.productPriceVaries === 'true';
      p.available   = btn.dataset.productAvailable === 'true';
    }
    return p;
  }

  // Il cuore di una scheda o della scheda prodotto porta lo stato di OGGI. Un
  // preferito salvato lo prende ogni volta che un cuore dello stesso prodotto
  // e' nella pagina (difetto del revisore, 07/10/2026: prima si completavano
  // solo i preferiti senza variante, cosi' un prodotto salvato esaurito e poi
  // tornato restava «Notify me» per sempre, e uno salvato disponibile e poi
  // esaurito mostrava «Add to cart» e riceveva un 422).
  // - disponibilita' e «prezzi diversi» sono del prodotto: ogni cuore dello
  //   stesso prodotto dice lo stesso;
  // - il prezzo solo se non varia (con prezzi diversi la scheda prodotto porta
  //   quello della variante scelta, le schede il minimo);
  // - la variante solo se manca: quella scelta nella scheda prodotto non si
  //   sovrascrive con la prima disponibile di una scheda (se e' finita lo vede
  //   la pagina dei preferiti, che chiede lo stato vivo).
  // Niente rimbalzi: un prodotto lo aggiorna un cuore solo per giro (il primo
  // nella pagina), e si aggiorna solo al caricamento e quando la griglia
  // cambia, mai per un cambio arrivato da un'altra scheda del browser (due
  // schede aperte con dati di ore diverse si riscriverebbero a vicenda). I
  // cuori della pagina dei preferiti sono fatti DAL preferito: non si leggono.
  function find(id) {
    id = String(id);
    for (var i = 0; i < wishlist.length; i++) { if (String(wishlist[i].id) === id) return wishlist[i]; }
    return null;
  }
  function fillSaved(btn, visti) {
    var v = variantFromBtn(btn);
    if (!v || btn.closest('#wlPageGrid')) return false;
    var id = String(btn.dataset.productId || btn.dataset.wishlist);
    if (visti[id]) return false;
    visti[id] = true;
    var p = find(id);
    if (!p) return false;
    var cambia = false;
    var disp = btn.dataset.productAvailable === 'true';
    var varia = btn.dataset.productPriceVaries === 'true';
    if (!p.variantId) { p.variantId = v; cambia = true; }
    if (p.available !== disp) { p.available = disp; cambia = true; }
    if (p.priceVaries !== varia) { p.priceVaries = varia; cambia = true; }
    if (!varia && btn.dataset.productPrice) {
      var raw = parseInt(btn.dataset.productPriceRaw || '0', 10) || 0;
      if (p.price !== btn.dataset.productPrice || p.priceRaw !== raw) {
        p.price = btn.dataset.productPrice; p.priceRaw = raw; cambia = true;
      }
    }
    return cambia;
  }

  // ── Heart animations ─────────────────────────────────────────
  function animateAdd(btn) {
    btn.classList.remove('wl-pulsing');
    void btn.offsetWidth; // force reflow
    btn.classList.add('wl-pulsing');
    btn.addEventListener('animationend', function () {
      btn.classList.remove('wl-pulsing');
    }, { once: true });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      spawnParticles(btn);
    }
  }

  function animateRemove(btn) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.style.transition = 'transform 300ms ease-out';
    btn.style.transform  = 'scale(0.82)';
    setTimeout(function () { btn.style.transform = ''; }, 300);
  }

  function spawnParticles(btn) {
    var rect = btn.getBoundingClientRect();
    var cx = rect.left + rect.width  / 2;
    var cy = rect.top  + rect.height / 2;
    [0, 60, 120, 180, 240, 300].forEach(function (angle) {
      var dist = 18 + Math.random() * 14;
      var rad  = angle * Math.PI / 180;
      var dx   = Math.cos(rad) * dist;
      var dy   = Math.sin(rad) * dist;
      var el   = document.createElement('div');
      el.style.cssText =
        'position:fixed;left:' + (cx - 3) + 'px;top:' + (cy - 3) +
        'px;pointer-events:none;z-index:9999;will-change:transform,opacity;' +
        'transition:transform 580ms ease, opacity 580ms ease;';
      el.innerHTML =
        '<svg width="6" height="6" viewBox="0 0 10 10" aria-hidden="true">' +
        '<path d="M5 9C5 9 1 6.2 1 3.5a2.5 2.5 0 015-0.3 2.5 2.5 0 015 0.3C11 6.2 5 9 5 9z"' +
        ' fill="#B8482E"/></svg>';
      document.body.appendChild(el);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0)';
          el.style.opacity   = '0';
          setTimeout(function () { el.remove(); }, 620);
        });
      });
    });
  }

  // ── Sync hearts across DOM ───────────────────────────────────
  // Re-run whenever the collection grid gains cards (Load More append,
  // filter reorder) so dynamically added hearts show their saved state.
  // riempi = true: i cuori aggiornano i preferiti salvati (fillSaved); solo al
  // caricamento e quando la griglia cambia, non per CHANGE_EVENT.
  document.addEventListener('col:gridUpdated', function () { syncHearts(true); });
  function syncHearts(riempi) {
    var filled = false;
    var visti = {};
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var id    = btn.dataset.productId || btn.dataset.wishlist;
      var saved = has(id);
      if (riempi === true && saved && fillSaved(btn, visti)) filled = true;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      /* Tappa 1b (WCAG 2.5.3): un bottone con la scritta visibile (data-wl-scritta: «Save to favourites» della scheda
         prodotto) si chiama con la sua scritta, in tutte le lingue; lo stato e' aria-pressed. Niente aria-label */
      if (btn.hasAttribute('data-wl-scritta')) { btn.removeAttribute('aria-label'); return; }
      var name = btn.dataset.productName || '';
      btn.setAttribute('aria-label',
        saved ? (I18N.removeFav || 'Remove %NAME% from favourites').replace('%NAME%', name) : (I18N.saveFav || 'Save %NAME% to favourites').replace('%NAME%', name));
    });
    // una scrittura sola per giro; il CHANGE_EVENT che ne segue non riempie
    if (filled) save();
  }

  // ── Badge ────────────────────────────────────────────────────
  function updateBadge() {
    var count = wishlist.length;
    document.querySelectorAll('[data-role="wishlist-badge"]').forEach(function (badge) {
      var prev = parseInt(badge.textContent, 10) || 0;
      badge.textContent = count > 99 ? '99+' : String(count);
      if (count === 0) {
        badge.classList.remove('is-visible');
      } else {
        badge.classList.add('is-visible');
        if (count !== prev) {
          badge.classList.remove('wl-badge--pulse');
          void badge.offsetWidth;
          badge.classList.add('wl-badge--pulse');
          badge.addEventListener('animationend', function () {
            badge.classList.remove('wl-badge--pulse');
          }, { once: true });
        }
      }
    });
    wlToggles().forEach(function (toggle) {
      toggle.setAttribute('aria-label',
        (I18N.viewFavorites || 'View favourites (9999)').replace('9999', count));
    });
  }

  // ── Panel state ──────────────────────────────────────────────
  var panelOpen = false;
  var panelLocked = false; // lock decision captured at open (resize-safe)
  var hoverTimer = null;

  function openPanel() {
    if (panelOpen) return;
    panelOpen = true;
    renderPanel();
    positionPanel();
    var panel   = document.getElementById('wlPanel');
    var overlay = document.getElementById('wlOverlay');
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.remove('is-closing');
      panel.classList.add('is-open');
      if (window.zgFocusTrap) zgFocusTrap.on(panel);
    }
    if (overlay) overlay.classList.add('is-active');
    wlToggles().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    // Foglio 07 §2 (f07-rotella): il blocco condiviso a ogni larghezza, non piu' solo nel foglio del telefono. Al
    // computer la tendina lasciava la rotella a Lenis, che faceva scorrere la pagina dietro; ora Lenis si ferma e la
    // rotella sopra l'elenco scorre .wl-body (data-lenis-prevent). panelLocked tiene on/off in pari.
    panelLocked = true;
    if (window.zgScrollLock) zgScrollLock.on();
    else document.body.style.overflow = 'hidden';
  }

  /* restoreFocus: only explicit closes (toggle/ESC/close control/overlay)
     refocus the toggle — hover-away and outside-click closes must not
     (BUG-175: a hover-only session has no pointerdown, so html.zg-mouse
     never suppressed the :focus-visible ring the programmatic focus()
     painted; the cart dropdown never refocuses on hover-close). Focus is
     still rescued whenever it sits INSIDE the closing panel, so it can
     never be stranded in an aria-hidden subtree. */
  function closePanel(restoreFocus) {
    // Look the element up BEFORE off(): passing undefined would release
    // whichever trap is active (e.g. the search overlay's).
    var panel   = document.getElementById('wlPanel');
    var rescueFocus = !!(panel && panel.contains(document.activeElement));
    if (window.zgFocusTrap) zgFocusTrap.off(panel);
    if (!panelOpen) return;
    panelOpen = false;
    var overlay = document.getElementById('wlOverlay');
    var toggle  = visibleWlToggle();
    if (panel) {
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      setTimeout(function () {
        panel.classList.remove('is-closing');
        panel.setAttribute('aria-hidden', 'true');
      }, 320);
    }
    if (overlay) overlay.classList.remove('is-active');
    wlToggles().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (panelLocked) {
      panelLocked = false;
      if (window.zgScrollLock) zgScrollLock.off();
      else document.body.style.overflow = '';
    }
    if (toggle && (restoreFocus || rescueFocus)) setTimeout(function () { toggle.focus(); }, 100);
  }

  function togglePanel() { if (panelOpen) closePanel(true); else openPanel(); }

  function positionPanel() {
    var panel  = document.getElementById('wlPanel');
    if (testataTelefono()) {
      // t2-soglia: il foglio dal basso lo mette il CSS (lux-wishlist.css). Si tolgono i valori scritti qui sotto al computer:
      // restano sul pannello anche chiuso, e aperto al computer, richiuso e riaperto sotto la soglia il foglio partiva dal
      // top dell'icona di prima (prima della voce succedeva solo passando i 768).
      if (panel) { panel.style.top = ''; panel.style.left = ''; panel.style.right = ''; panel.style.transformOrigin = ''; }
      return;
    }
    var toggle = visibleWlToggle();
    if (!toggle || !panel) return;
    var rect = toggle.getBoundingClientRect();
    panel.style.top   = (rect.bottom + 10) + 'px';
    // Giro finale, tappa 1b (b-bassi-carrello, correzioni del revisore): la gemella di positionDropdown in
    // lux-cart.js, stesso difetto e stessa cura. In arabo l'icona sta a sinistra e il pannello largo 380 px, appeso al
    // suo bordo destro, usciva dallo schermo a sinistra (banco del revisore: a 768 se ne vedevano 106 px, a 1920
    // 249). Da destra a sinistra si appende al bordo sinistro dell'icona e si apre verso il centro, fra 16 px e
    // innerWidth - larghezza - 16; da sinistra a destra resta com'era, uguale al pixel. Si cambiano insieme.
    if (getComputedStyle(document.documentElement).direction === 'rtl') {
      panel.style.left  = Math.max(16, Math.min(rect.left, window.innerWidth - panel.offsetWidth - 16)) + 'px';
      panel.style.right = 'auto';
      panel.style.transformOrigin = 'top left';
    } else {
      panel.style.right = (window.innerWidth - rect.right) + 'px';
      panel.style.left  = 'auto';
      panel.style.transformOrigin = '';
    }
  }

  // ── Panel render ─────────────────────────────────────────────
  function renderPanel() {
    var list    = document.getElementById('wlList');
    var empty   = document.getElementById('wlEmpty');
    var footer  = document.getElementById('wlFooter');
    var countEl = document.getElementById('wlPanelCount');
    if (!list) return;

    var count = wishlist.length;
    if (countEl) countEl.textContent = count === 1
      ? (I18N.itemOne || '1 item')
      : (I18N.itemsOther || '9999 items').replace('9999', count);

    if (count === 0) {
      if (empty)  empty.style.display  = '';
      list.style.display   = 'none';
      if (footer) footer.style.display = 'none';
    } else {
      if (empty)  empty.style.display  = 'none';
      list.style.display   = '';
      if (footer) footer.style.display = '';
      list.innerHTML = '';
      wishlist.forEach(function (p) { list.appendChild(buildItemEl(p)); });
    }
  }

  function buildItemEl(product) {
    var div = document.createElement('div');
    div.className = 'wl-item';
    div.dataset.wlId = product.id;
    var thumb = product.image
      ? '<img class="wl-item__thumb" src="' + esc(product.image) + '" alt="" loading="lazy">'
      : '<div class="wl-item__thumb-placeholder"></div>';
    div.innerHTML =
      thumb +
      '<div class="wl-item__info">' +
        '<p class="wl-item__name">'   + esc(product.name)     + '</p>' +
        (product.producer
          ? '<p class="wl-item__vendor">' + esc(product.producer) + '</p>'
          : '') +
        '<p class="wl-item__price">'  + esc(product.price)    + '</p>' +
      '</div>' +
      /* aria-label da I18N, non scritto a mano: era in inglese in tutte e sette
         le lingue e con la grafia americana. Va escapato perche qui finisce
         dentro un attributo per concatenazione, non via setAttribute. */
      '<button class="wl-item__remove" aria-label="' +
        esc((I18N.removeFav || 'Remove %NAME% from favourites').replace('%NAME%', product.name)) +
        '" data-wl-remove="' + product.id + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"' +
        ' stroke-linecap="round" aria-hidden="true">' +
        '<path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>';

    div.addEventListener('click', function (e) {
      if (e.target.closest('[data-wl-remove]')) return;
      var dove = urlPagina(product);   // nella lingua della pagina, non in quella del salvataggio
      if (dove) { closePanel(false); window.location.href = dove; }
    });
    div.querySelector('[data-wl-remove]').addEventListener('click', function (e) {
      e.stopPropagation();
      animateRemoveItem(div, product.id);
    });
    return div;
  }

  function animateRemoveItem(el, id) {
    var h = el.offsetHeight;
    el.classList.add('wl-removing');
    setTimeout(function () {
      el.style.maxHeight    = h + 'px';
      el.style.overflow     = 'hidden';
      el.style.paddingTop   = '';
      el.style.paddingBottom = '';
      requestAnimationFrame(function () {
        el.style.transition = 'max-height 300ms ease-out, padding 300ms ease-out';
        el.style.maxHeight  = '0';
        el.style.paddingTop = '0';
        el.style.paddingBottom = '0';
        setTimeout(function () { remove(id); }, 310);
      });
    }, 255);
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── Mobile swipe to close ────────────────────────────────────
  function initSwipe() {
    var panel  = document.getElementById('wlPanel');
    var handle = panel && panel.querySelector('.wl-handle');
    if (!handle) return;
    var startY = 0;

    handle.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!panelOpen || !handle._dragging) return;
      var dy = e.touches[0].clientY - startY;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });

    handle.addEventListener('touchmove', function () {
      handle._dragging = true;
      panel.classList.add('is-dragging');
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      if (!handle._dragging) return;
      handle._dragging = false;
      // Re-enable the transition before resetting so the snap-back animates
      panel.classList.remove('is-dragging');
      var dy = e.changedTouches[0].clientY - startY;
      panel.style.transform = '';
      if (dy > 80) closePanel(true);
    }, { passive: true });
  }

  // ── Wishlist dedicated page ──────────────────────────────────
  function initPage() {
    var grid    = document.getElementById('wlPageGrid');
    if (!grid) return;
    renderPage();
    var sortEl = document.getElementById('wlPageSort');
    if (sortEl) sortEl.addEventListener('change', renderPage);
    document.addEventListener(CHANGE_EVENT, renderPage);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#wlPageClearBtn')) return;
      if (confirm(I18N.clearConfirm || 'Remove all favourites?')) clear();
    });
  }

  // ── Stato vivo nella pagina dei preferiti (giro finale, voce 1) ──
  // Il gesto d'acquisto si decide SOLO da uno stato confermato in questa
  // visita: per ogni preferito una GET a <root>products/<handle>.js (stessa
  // origine, sola lettura, quattro alla volta). Finche' non arriva, e se non
  // arriva (prodotto tolto o rinominato, rete), la scheda mostra «View full
  // details», come i preferiti senza variante: mai un «Add to cart» che
  // riceverebbe un 422, mai «Notify me» su un prodotto tornato. Lo stato
  // confermato aggiorna anche il preferito (disponibilita', prezzi diversi,
  // prezzo di oggi, la variante se mancava) e si scrive senza CHANGE_EVENT,
  // per non ricostruire la griglia sotto il fuoco della tastiera.
  var vivo = {};      // id -> { available, priceVaries, variantId, vedi }
  var chiesti = {};   // id -> true: gia' chiesto in questa visita
  function handleDa(url) { var m = /\/products\/([^\/?#]+)/.exec(url || ''); return m ? m[1] : ''; }
  function radice() { var r = (window.routes && window.routes.root) || '/'; return r.replace(/\/?$/, '/'); }
  // L'indirizzo del preferito nella lingua della PAGINA (tappa 1b, correzioni del
  // revisore di b-prefisso). Quello salvato e' product.url della lingua del clic sul
  // cuore: un preferito salvato da /products/x apriva la scheda inglese anche da /ar/.
  // Si ricostruisce come la GET dello stato vivo: radice() + 'products/' + handle (via
  // anche i parametri della ricerca, _pos e _sid); l'indirizzo salvato com'e' solo se
  // non ha un handle. Usato dove si stampa o si apre: pannello, schede e gesti della
  // pagina dei preferiti. Il preferito salvato non cambia.
  function urlPagina(p) {
    var u = (p && p.url) || '', h = handleDa(u);
    if (!h) return u;
    try { h = encodeURIComponent(decodeURIComponent(h)); } catch (e) { h = encodeURIComponent(h); }
    return radice() + 'products/' + h;
  }
  function inMoneta(cents, prima) {
    return typeof window.zagaraFormatMoney === 'function' ? window.zagaraFormatMoney(cents) : prima;
  }
  function persisti() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist)); } catch (e) {}
  }
  function statoVivo(p, prod) {
    var sv = String(p.variantId || '').replace(/\D/g, '');
    var salvata = null, prima = null;
    (prod.variants || []).forEach(function (x) {
      if (String(x.id) === sv) salvata = x;
      if (!prima && x.available) prima = x;
    });
    var s = { available: !!prod.available, priceVaries: !!prod.price_varies, variantId: '', vedi: false };
    if (s.available && !s.priceVaries) {
      if (salvata && salvata.available) s.variantId = String(salvata.id);
      else if (!sv && prima) s.variantId = String(prima.id);   // preferito vecchio: la prima disponibile, come la scheda
      else s.vedi = true;   // la variante scelta e' finita o non c'e' piu': si sceglie nella scheda prodotto
    }
    var cambia = false;
    if (p.available !== s.available) { p.available = s.available; cambia = true; }
    if (p.priceVaries !== s.priceVaries) { p.priceVaries = s.priceVaries; cambia = true; }
    if (!sv && s.variantId) { p.variantId = s.variantId; cambia = true; }
    var cents = salvata ? salvata.price : prod.price;
    if (typeof cents === 'number' && cents >= 0 && p.priceRaw !== cents) {
      p.priceRaw = cents; p.price = inMoneta(cents, p.price); cambia = true;
    }
    vivo[String(p.id)] = s;
    return cambia;
  }
  // rimette prezzo e gesto di UNA scheda gia' nella pagina, senza ricostruire
  // la griglia; il fuoco, se era sul gesto vecchio, passa a quello nuovo
  function aggiornaScheda(p) {
    var grid = document.getElementById('wlPageGrid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.col-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-product-id') !== String(p.id)) continue;
      var row = cards[i].querySelector('.col-card__priceRow');
      if (!row) return;
      var aveva = row.contains(document.activeElement);
      row.innerHTML = priceHtml(p) + pageAction(p);
      if (aveva) { var g = row.querySelector('a, button'); if (g) g.focus(); }
      return;
    }
  }
  function chiediVivo() {
    var coda = wishlist.filter(function (p) { return !chiesti[String(p.id)]; });
    coda.forEach(function (p) { chiesti[String(p.id)] = true; });
    var attivi = 0, cambiato = false;
    function prossimo() {
      if (!coda.length) { if (!attivi && cambiato) { cambiato = false; persisti(); } return; }
      var p = coda.shift(), h = handleDa(p.url);
      if (!h) { prossimo(); return; }
      try { h = encodeURIComponent(decodeURIComponent(h)); } catch (e) { h = encodeURIComponent(h); }
      attivi++;
      fetch(radice() + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (prod) {
          if (!prod || String(prod.id) !== String(p.id)) return;   // handle passato a un altro prodotto: resta «View full details»
          if (statoVivo(p, prod)) cambiato = true;
          aggiornaScheda(p);
        })
        .catch(function () { /* resta «View full details» */ })
        .then(function () { attivi--; prossimo(); });
    }
    for (var i = 0; i < 4; i++) prossimo();
  }

  function renderPage() {
    var grid    = document.getElementById('wlPageGrid');
    var empty   = document.getElementById('wlPageEmpty');
    var countEl = document.getElementById('wlPageCount');
    var bar     = document.getElementById('wlPageBar');
    if (!grid) return;
    var count = wishlist.length;
    if (countEl) countEl.textContent = count + ' product' + (count === 1 ? '' : 's') + ' saved';
    if (count === 0) {
      if (empty) empty.style.display = '';
      if (bar)   bar.style.display   = 'none';
      grid.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (bar)   bar.style.display   = '';
    grid.style.display = '';
    var sortEl = document.getElementById('wlPageSort');
    var sort   = sortEl ? sortEl.value : 'recent';
    var sorted = wishlist.slice();
    if (sort === 'name-az')     sorted.sort(function (a,b) { return (a.name||'').localeCompare(b.name||''); });
    else if (sort === 'price-asc')  sorted.sort(function (a,b) { return (a.priceRaw||0) - (b.priceRaw||0); });
    else if (sort === 'price-desc') sorted.sort(function (a,b) { return (b.priceRaw||0) - (a.priceRaw||0); });
    else sorted.sort(function (a,b) { return (b.addedAt||0) - (a.addedAt||0); });
    grid.innerHTML = '';
    sorted.forEach(function (p) { grid.appendChild(buildPageCard(p)); });
    chiediVivo();
  }

  // Il gesto d'acquisto della scheda dei preferiti (giro finale, voce 1): la
  // stessa scelta di snippets/zg-product-card.liquid e lo stesso componente
  // (.zg-btn--cart, variante a contorno), ma SOLO dallo stato vivo confermato
  // in questa visita (vivo, qui sopra). Disponibile e prezzo unico -> il
  // bottone [data-add-to-cart] del gestore globale di luxury.js (POST
  // /cart/add, poi il cassetto; un 422 lo mostra showAtcError), con la scritta
  // corta e il nome accessibile col nome del prodotto che la contiene (WCAG
  // 2.5.3); prezzi diversi -> la scelta della misura nella scheda prodotto;
  // esaurito -> «Notify me». Stato non ancora confermato o non confermabile ->
  // «View full details». Le etichette che ZAGARA.i18n non ha arrivano come
  // data-wl-* su #wlPageGrid (sections/lux-wishlist-page.liquid).
  function pageAction(product) {
    var grid = document.getElementById('wlPageGrid');
    var d = (grid && grid.dataset) || {};
    var name = product.name || '';
    var url = urlPagina(product) || '#';
    var s = vivo[String(product.id)];
    if (!s || s.vedi) {
      return '<a class="col-card__btn-thin col-card__view" href="' + esc(url) + '"><span class="col-card__btn-text">' +
        esc(d.wlView || 'View full details') + '</span></a>';
    }
    if (!s.available) {
      return '<a class="col-card__btn-thin col-card__notify" href="' + esc(url) + '#notify" aria-label="' +
        esc((d.wlNotifyAria || 'Notify me when %NAME% is back in stock').replace('%NAME%', name)) + '"><span class="col-card__btn-text">' +
        esc(I18N.notifyMe || 'Notify me') + '</span></a>';
    }
    if (s.priceVaries) {
      return '<a class="col-card__btn-thin col-card__choose zg-btn--cart zg-btn--cart-outline" href="' + esc(url) + '"><span class="col-card__btn-text">' +
        esc(d.wlChoose || 'Choose a size') + '</span></a>';
    }
    return '<button type="button" class="col-card__quick-add col-card__btn-thin zg-btn--cart zg-btn--cart-outline" data-add-to-cart="' + esc(s.variantId) + '" aria-label="' +
      esc((d.wlAtcAria || 'Add %NAME% to cart').replace('%NAME%', name)) + '">' +
      '<span class="col-card__add-text">' + esc(d.wlAdd || 'Add') + '</span>' +
      '<svg class="col-card__add-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>' +
      '</button>';
  }
  function priceHtml(product) {
    return product.price ? '<span class="col-card__price">' + esc(product.price) + '</span>' : '';
  }

  function buildPageCard(product) {
    var art = document.createElement('article');
    art.className = 'col-card';
    art.setAttribute('data-product-id', product.id);
    var thumb = product.image
      ? '<img class="col-card__bg" src="' + esc(product.image) + '" alt="' + esc(product.name) + '" loading="lazy">'
      : '<div class="col-card__bg-placeholder"></div>';
    var metaHtml = product.producer
      ? '<p class="col-card__meta">' + esc(product.producer) + '</p>'
      : '';
    var dove = urlPagina(product) || '#';   // i link nella lingua della pagina; il cuore porta il preferito com'e'
    art.innerHTML =
      '<div class="col-card__frame">' +
        '<a href="' + esc(dove) + '" class="col-card__cover" aria-label="' + esc(product.name) + '"></a>' +
        '<div class="col-card__media">' + thumb + '</div>' +
        '<div class="col-card__shine" aria-hidden="true"></div>' +
        '<button class="col-card__wishlist col-card__wishlist--active is-saved"' +
          ' data-wishlist="' + product.id + '"' +
          ' data-product-id="' + product.id + '"' +
          ' data-product-name="' + esc(product.name) + '"' +
          ' data-product-price="' + esc(product.price || '') + '"' +
          ' data-product-price-raw="' + (product.priceRaw || 0) + '"' +
          ' data-product-image="' + esc(product.image || '') + '"' +
          ' data-product-url="' + esc(product.url || '') + '"' +
          ' data-product-vendor="' + esc(product.producer || '') + '"' +
          /* niente variante ne' stato su questo cuore: e' fatto DAL preferito, non e' una fonte (fillSaved) */
          ' aria-pressed="true"' +
          ' aria-label="' + esc((I18N.removeFav || 'Remove %NAME% from favourites').replace('%NAME%', product.name)) + '">' +
          '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="col-card__info">' +
        '<h3 class="col-card__title"><a href="' + esc(dove) + '">' + esc(product.name) + '</a></h3>' +
        metaHtml +
        '<div class="col-card__priceRow">' + priceHtml(product) + pageAction(product) + '</div>' +
      '</div>';
    return art;
  }

  // ── Event wiring ─────────────────────────────────────────────
  function initToggle() {
    var toggles = wlToggles();
    if (!toggles.length) return;
    var closeTimer = null;
    function scheduleClose() {
      if (testataTelefono()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { if (panelOpen) closePanel(false); }, 260);
    }
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        clearTimeout(hoverTimer);
        clearTimeout(closeTimer);
        togglePanel();
      });
      /* il mouse apre quando si MUOVE sull'icona (come la tendina «Shop», luxury.js, initTendina; correzioni di
         t2-unione-f07, D3): mouseenter arriva anche quando e' la testata a tornare sotto il puntatore fermo, e la tendina
         aperta ferma la pagina */
      var entrato = false;
      toggle.addEventListener('mouseenter', function () {
        if (testataTelefono()) return;
        clearTimeout(closeTimer);
        entrato = true;
      });
      toggle.addEventListener('mousemove', function () {
        if (!entrato || testataTelefono()) return;
        entrato = false;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(openPanel, 200);
      });
      toggle.addEventListener('mouseleave', function () {
        entrato = false;
        clearTimeout(hoverTimer);
        scheduleClose();
      });
    });
    // Keep the panel open while the cursor is over it; close shortly after leaving.
    var panel = document.getElementById('wlPanel');
    if (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
    }
  }

  // Heart buttons — delegated listener on document (capture phase beats card link clicks)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    if (btn.getAttribute('data-role') === 'wishlist-toggle') return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var id = btn.dataset.productId || btn.dataset.wishlist;
    var nowSaved = !has(id);
    // Immediately update this button's visual state without waiting for CHANGE_EVENT chain
    btn.classList.toggle('is-saved', nowSaved);
    btn.classList.toggle('col-card__wishlist--active', nowSaved);
    btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
    if (nowSaved) {
      add(productFromBtn(btn));
      animateAdd(btn);
    } else {
      remove(id);
      animateRemove(btn);
    }
  }, true);

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panelOpen) closePanel(true);
  });

  // Close on outside pointer
  document.addEventListener('pointerdown', function (e) {
    if (!panelOpen) return;
    var panel = document.getElementById('wlPanel');
    if (panel && panel.contains(e.target)) return;
    if (e.target && e.target.closest && e.target.closest('[data-role="wishlist-toggle"]')) return;
    closePanel(false);
  });

  // Overlay tap (mobile)
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'wlOverlay') closePanel(true);
  });

  // data-wl-close links inside panel
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wl-close]')) closePanel(true);
  });

  // Clear all button inside panel
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#wlClearBtn')) return;
    if (confirm(I18N.clearConfirm || 'Remove all favourites?')) clear();
  });

  // Giro finale, tappa 2, voce t2-soglia: passando la soglia della testata del telefono, nei due sensi, il pannello aperto
  // si chiude, come il menu e la tendina «Shop» (luxury.js, allaSoglia): cambia forma (foglio dal basso col velo, pannello
  // ancorato all'icona) e l'icona da cui si era aperto non si vede piu'. Prima restava aperto con la posizione dell'altra
  // forma (banco: aperto a 1280 e stretto a 1000, il foglio partiva dal top 72 e usciva di 120 px a sinistra, col velo e
  // la pagina ferma). closePanel riporta all'icona che si vede il fuoco rimasto dentro.
  (function () {
    var mq = window.ZAGARA && window.ZAGARA.testataTelefono;
    if (!mq) return;
    function passa() { if (panelOpen) closePanel(false); }
    if (mq.addEventListener) mq.addEventListener('change', passa);
    else if (mq.addListener) mq.addListener(passa);
  })();

  // Reposition on resize (rAF-batched: window drags fire resize every frame)
  var resizeTicking = false;
  window.addEventListener('resize', function () {
    if (!panelOpen || resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(function () {
      resizeTicking = false;
      if (panelOpen) positionPanel();
    });
  });

  // React to state changes everywhere
  document.addEventListener(CHANGE_EVENT, function () {
    syncHearts(false);
    updateBadge();
    if (panelOpen) renderPanel();
  });

  // ── Init ─────────────────────────────────────────────────────
  function init() {
    load();
    syncHearts(true);
    updateBadge();
    initToggle();
    initSwipe();
    initPage();
    // Re-sync hearts when lux-collection.js rebuilds the grid (filter/load-more):
    // the listener near syncHearts already does it, with the fill (one is enough)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  window.zagaraWishlist = { add: add, remove: remove, has: has, clear: clear,
    get: function () { return wishlist.slice(); } };
})();
